import { ChevronLeft, ChevronRight } from 'lucide-react';
import { clsx } from 'clsx';

interface PaginationControlsProps {
  page: number;          // zero-based
  pageSize: number;
  totalCount: number;    // size of the current page (we don't get a true total)
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export function PaginationControls({
  page,
  pageSize,
  totalCount,
  hasPrev,
  hasNext,
  onPrev,
  onNext,
}: PaginationControlsProps) {
  const start = page * pageSize + 1;
  const end = page * pageSize + totalCount;

  return (
    <div className="flex items-center justify-between border-t border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-500">
      <span>
        Showing {start}-{end} of {totalCount + page * pageSize}
        {hasNext ? '+' : ''}
      </span>
      <div className="flex gap-1">
        <button
          type="button"
          disabled={!hasPrev}
          onClick={onPrev}
          className={clsx(
            'flex items-center gap-1 rounded border border-slate-200 px-2 py-1',
            hasPrev
              ? 'bg-white hover:bg-slate-100 text-slate-700'
              : 'bg-slate-50 text-slate-400 cursor-not-allowed',
          )}
        >
          <ChevronLeft size={14} /> Prev
        </button>
        <button
          type="button"
          disabled={!hasNext}
          onClick={onNext}
          className={clsx(
            'flex items-center gap-1 rounded border border-slate-200 px-2 py-1',
            hasNext
              ? 'bg-white hover:bg-slate-100 text-slate-700'
              : 'bg-slate-50 text-slate-400 cursor-not-allowed',
          )}
        >
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
